module.exports = __webpack_public_path__ + "static/media/boatramp.e0a22b5f.svg";